import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.532 5a20.761 20.761 0 0 0-8.782 1.973v3.31a6 6 0 0 1 3.75 1.974 5.96 5.96 0 0 1 0 7.904 6 6 0 0 1-3.75 1.974V27a22.324 22.324 0 0 1 8.782-1.823H28V5h-2.468ZM10 16.21a5.969 5.969 0 0 1 1.503-3.95 6.01 6.01 0 0 1 3.747-1.977v-3.31A20.761 20.761 0 0 0 6.467 5H4v20.177h2.467c3.022.007 6.01.628 8.783 1.823v-4.865a6.01 6.01 0 0 1-3.747-1.976A5.969 5.969 0 0 1 10 16.21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.942c2.577 0 4.667-2.082 4.667-4.65 0-2.568-2.09-4.65-4.667-4.65s-4.667 2.082-4.667 4.65c0 2.568 2.09 4.65 4.667 4.65Zm-2-5.465c.032-1.069.832-1.842 1.96-1.842 1.064 0 1.824.678 1.824 1.634 0 .846-.48 1.22-.896 1.545-.323.251-.608.474-.608.863h-.896c0-.806.444-1.142.838-1.441.317-.24.602-.456.602-.871 0-.486-.368-.821-.896-.821-.592 0-1 .422-1.016 1.02L14 15.477Zm2.472 3.292a.603.603 0 0 1-.616.605.608.608 0 0 1-.616-.605c0-.343.272-.606.616-.606.352 0 .616.263.616.606Z",
    fill: "currentColor"
  }));
};

var SvgDocumentation = styled(SvgComponent).withConfig({
  displayName: "Documentation__SvgDocumentation",
  componentId: "sc-o4ctyd-0"
})(["", " ", ""], size, color);
export default SvgDocumentation;